export function createDataGraph(years, months, arrayPond, indexPond) {
  const dataGraphTemp = years?.slice(0, -1).map((_, r) => months[r]?.map((month) => ({ name: `${month.name}/${years[r]}` })));

  arrayPond[indexPond]?.listSuply.forEach((element) => {
    if (element.name === 'Total') return;

    element.details.slice(0, -1).forEach((detail, i) => {
      detail.forEach((d, y) => {
        if (dataGraphTemp[i] && dataGraphTemp[i][y]) {
          dataGraphTemp[i][y][`${element.name}`] = parseFloat(d?.total);
        }
      });
    });
  });

  return dataGraphTemp.flat();
}

export function createListItemsName(arrayPond, indexPond) {
  const listItemsName = [];
  arrayPond[indexPond]?.listSuply.forEach((element) => {
    if (element.name === 'Total') return;

    element.details.slice(0, -1).forEach(() => {
      if (!listItemsName.some((e) => e.name === element.name && e.type === element.suply_type_name)) {
        listItemsName.push({
          name: element.name,
          type: element.suply_type_name,
        });
      }
    });
  });

  return listItemsName;
}
